import Vue from 'vue'
import Vuex from 'vuex'
import user from './module/user' //  用户模块

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user
  }
})
